import './logic';
import './variables';
import { wrapperBuilder } from './build';

export const NotificationWrapper = wrapperBuilder.build();
